import wechat from '../wechat'

export const Roles = ['技术员', '试验员', '操作手']

let appid = ''
let redirectUri = ''

if (process.env.BUILD_TEST) {
  appid = wechat.buildtest.appId
  redirectUri = wechat.buildtest.redirectUri
} else if (process.env.NODE_ENV === 'production') {
  appid = wechat.build.appId
  redirectUri = wechat.build.redirectUri
} else {
  appid = wechat.dev.appId
  redirectUri = wechat.dev.redirectUri
}

export const AUTHURL = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_base&state=keaowechat#wechat_redirect`

export const AdviceTypesEN2CN = {
  bridge: '桥梁',
  tunnel: '隧道',
  subgrade: '路基',
  other: '临建'
}



// WEBPACK FOOTER //
// ./src/services/consts.js